import React, { Component } from 'react';
import App from './App';
import { BrowserRouter, useHistory } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Auth0Provider } from '@auth0/auth0-react';
import { UserContextProvider } from './UserContextProvider';
import PublicShareLayout from './pages/PublicShareLayout';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const domain = process.env.REACT_APP_AUTH_DOMAIN;
const clientId = process.env.REACT_APP_CLIENT_ID;
const audience = process.env.REACT_APP_AUDIENCE;

// Auth0Provider sits INSIDE the router so the post-login restore
// (appState.returnTo, sent by LoginButton and the re-auth bounce in
// UserContextProvider) navigates through the ROUTER's history. The previous
// window.history.replaceState restore updated the URL bar but BrowserRouter
// never observes native replaceState (no event fires), so the router kept
// rendering the callback path "/" and its authenticated redirect sent every
// deep link to /dashboard.
const Auth0WithRouterRedirect = ({ children }) => {
    const history = useHistory();
    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            useRefreshTokens={true}
            cacheLocation={'localstorage'}
            onRedirectCallback={(appState) => {
                // replace, not push: the Auth0 callback URL must not stay in
                // the back stack. Without a returnTo (a plain visit to "/"),
                // "/" keeps today's behavior and redirects to the dashboard.
                history.replace(appState?.returnTo || '/');
            }}
            authorizationParams={{
                redirect_uri: window.location.origin,
                scope: 'openid profile email phone offline_access all',
                audience: audience
            }}
        >
            {children}
        </Auth0Provider>
    );
};

class AppWithAuth extends Component {
    render() {
        // /share/* paths are unauthenticated brand-funnel pages: skip Auth0 +
        // UserContextProvider so the global axios interceptor never installs and
        // no Auth0 silent-auth iframe fires for cold visitors.
        if (typeof window !== 'undefined' && window.location.pathname.startsWith('/share/')) {
            return <PublicShareLayout />;
        }

        return (
            <BrowserRouter>
                <Auth0WithRouterRedirect>
                    <UserContextProvider>
                        <Elements stripe={stripePromise}>
                            <App />
                        </Elements>
                    </UserContextProvider>
                </Auth0WithRouterRedirect>
            </BrowserRouter>
        );
    }
}

export default AppWithAuth;
